import dayjs from 'dayjs';
import { ExportOptions } from '../../../types/Export/ExportOptions.types';

const escapeCSV = (value: string): string => `"${value.replace(/"/g, '""')}"`;

export function buildAndDownloadCSV<T>(
  data: T[],
  options: ExportOptions<T>,
  filenamePrefix: string,
): void {
  const selectedOptions = Object.values(options).filter((option) => option.selected);

  const exportData: string[][] = [
    selectedOptions.map((option) => option.label),
    ...data.map((row) => selectedOptions.map((option) => {
      const value = row[option.key];
      const formatted = option.transform ? option.transform(value) : String(value ?? '');
      return formatted || '-';
    })),
  ];

  const csvContent = `data:text/csv;charset=utf-8,${exportData.map((row) => row.map(escapeCSV).join(',')).join('\n')}`;
  const link = document.createElement('a');
  link.href = encodeURI(csvContent);
  link.download = `ZeroDash ${filenamePrefix} Export ${dayjs().format('YYYYMMDD_hhmmss')}.csv`;
  link.click();
  link.remove();
}
